module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style6/message-alert-style6.component.scss
// module id = ./src/app/features/message-alert/message-alert-style6/message-alert-style6.component.scss
// module chunks = main